import {
  ActiveTabBackground,
  Tab,
  TabNumber,
  TabsSwitcherWrapper,
} from './styled';

interface TabsSwitcherProps {
  tabs: { value: unknown; label: string }[];
  currentTabValue: string;
  onChange: (val: unknown) => void;
}

export const TabsSwitcher = ({
  currentTabValue,
  tabs,
  onChange,
}: TabsSwitcherProps) => {
  const activeTabIndex = tabs.findIndex(tab => tab.value === currentTabValue);

  return (
    <TabsSwitcherWrapper>
      <ActiveTabBackground
        activeTabPos={activeTabIndex}
        tabsCount={tabs.length}
      />
      {tabs.map(tab => {
        const tabValue = tab.value;
        const match = tab.label.match(/^(.+?)\s(\d+)$/);
        const label = match ? match[1] : tab.label;
        const number = match ? match[2] : null;
        const isActive = tabValue === currentTabValue;

        return (
          <Tab
            onClick={() => onChange(tabValue)}
            key={tabValue as any}
            isActive={isActive}>
            {label}
            {number && <TabNumber isActive={isActive}>{number}</TabNumber>}
          </Tab>
        );
      })}
    </TabsSwitcherWrapper>
  );
};
